/** First character uppercase, rest lowercase (sentence-style error copy). */
export function formatInputErrorMessage(message) {
  if (message == null) return message;
  const str = String(message);
  const trimmed = str.trim();
  if (!trimmed) return str;
  return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
}
